import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const NuSkuTeamBusinessClassPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NuSkuTeamBusinessClassPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconfirmed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newSubscriptionListPriceQuotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeUnconfirmed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconfirmed"}}},{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cBillableCollaborators"}},{"kind":"Field","name":{"kind":"Name","value":"cTeamMembers"}},{"kind":"Field","name":{"kind":"Name","value":"ixSubscriptionProduct"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotal"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotalPerUser"}},{"kind":"Field","name":{"kind":"Name","value":"nTax"}},{"kind":"Field","name":{"kind":"Name","value":"nTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthly"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cBillableCollaborators"}},{"kind":"Field","name":{"kind":"Name","value":"cTeamMembers"}},{"kind":"Field","name":{"kind":"Name","value":"ixSubscriptionProduct"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotal"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotalPerUser"}},{"kind":"Field","name":{"kind":"Name","value":"nTax"}},{"kind":"Field","name":{"kind":"Name","value":"nTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nAnnualPercentageSavings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cBillableCollaborators"}},{"kind":"Field","name":{"kind":"Name","value":"cTeamMembers"}},{"kind":"Field","name":{"kind":"Name","value":"dtPricingAdjustmentExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"ixSubscriptionProduct"}},{"kind":"Field","name":{"kind":"Name","value":"nPricingAdjustment"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotal"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotalPerUser"}},{"kind":"Field","name":{"kind":"Name","value":"nTax"}},{"kind":"Field","name":{"kind":"Name","value":"nTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sTaxRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthly"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cBillableCollaborators"}},{"kind":"Field","name":{"kind":"Name","value":"cTeamMembers"}},{"kind":"Field","name":{"kind":"Name","value":"dtPricingAdjustmentExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"ixSubscriptionProduct"}},{"kind":"Field","name":{"kind":"Name","value":"nPricingAdjustment"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotal"}},{"kind":"Field","name":{"kind":"Name","value":"nSubtotalPerUser"}},{"kind":"Field","name":{"kind":"Name","value":"nTax"}},{"kind":"Field","name":{"kind":"Name","value":"nTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sTaxRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nAnnualPercentageSavings"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"NuSkuTeamBusinessClassPrices","document":NuSkuTeamBusinessClassPricesDocument}} as const;
export type NuSkuTeamBusinessClassPricesQueryVariables = Types.Exact<{
  includeUnconfirmed?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  orgId: Types.Scalars['ID']['input'];
  product: Types.Scalars['Int']['input'];
}>;


export type NuSkuTeamBusinessClassPricesQuery = (
  { __typename: 'Query' }
  & { newSubscriptionListPriceQuotes: (
    { __typename: 'ListPriceQuoteInfo' }
    & {
      base: (
        { __typename: 'PriceQuoteInfo' }
        & Pick<Types.PriceQuoteInfo, 'nAnnualPercentageSavings'>
        & {
          annual?: Types.Maybe<(
            { __typename: 'PriceQuote' }
            & Pick<
              Types.PriceQuote,
              | 'cBillableCollaborators'
              | 'cTeamMembers'
              | 'ixSubscriptionProduct'
              | 'nSubtotal'
              | 'nSubtotalPerUser'
              | 'nTax'
              | 'nTotal'
            >
          )>,
          monthly?: Types.Maybe<(
            { __typename: 'PriceQuote' }
            & Pick<
              Types.PriceQuote,
              | 'cBillableCollaborators'
              | 'cTeamMembers'
              | 'ixSubscriptionProduct'
              | 'nSubtotal'
              | 'nSubtotalPerUser'
              | 'nTax'
              | 'nTotal'
            >
          )>,
        }
      ),
      subscriber: (
        { __typename: 'PriceQuoteInfo' }
        & Pick<Types.PriceQuoteInfo, 'nAnnualPercentageSavings'>
        & {
          annual?: Types.Maybe<(
            { __typename: 'PriceQuote' }
            & Pick<
              Types.PriceQuote,
              | 'cBillableCollaborators'
              | 'cTeamMembers'
              | 'dtPricingAdjustmentExpiration'
              | 'ixSubscriptionProduct'
              | 'nPricingAdjustment'
              | 'nSubtotal'
              | 'nSubtotalPerUser'
              | 'nTax'
              | 'nTotal'
              | 'sTaxRegion'
            >
          )>,
          monthly?: Types.Maybe<(
            { __typename: 'PriceQuote' }
            & Pick<
              Types.PriceQuote,
              | 'cBillableCollaborators'
              | 'cTeamMembers'
              | 'dtPricingAdjustmentExpiration'
              | 'ixSubscriptionProduct'
              | 'nPricingAdjustment'
              | 'nSubtotal'
              | 'nSubtotalPerUser'
              | 'nTax'
              | 'nTotal'
              | 'sTaxRegion'
            >
          )>,
        }
      ),
    }
  ) }
);

/**
 * __useNuSkuTeamBusinessClassPricesQuery__
 *
 * To run a query within a React component, call `useNuSkuTeamBusinessClassPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNuSkuTeamBusinessClassPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNuSkuTeamBusinessClassPricesQuery({
 *   variables: {
 *      includeUnconfirmed: // value for 'includeUnconfirmed'
 *      orgId: // value for 'orgId'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useNuSkuTeamBusinessClassPricesQuery(
  baseOptions: TrelloQueryHookOptions<
    NuSkuTeamBusinessClassPricesQuery,
    NuSkuTeamBusinessClassPricesQueryVariables
  > &
    (
      | {
          variables: NuSkuTeamBusinessClassPricesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: NuSkuTeamBusinessClassPricesDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    NuSkuTeamBusinessClassPricesQuery,
    NuSkuTeamBusinessClassPricesQueryVariables
  >(NuSkuTeamBusinessClassPricesDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useNuSkuTeamBusinessClassPricesLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    NuSkuTeamBusinessClassPricesQuery,
    NuSkuTeamBusinessClassPricesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NuSkuTeamBusinessClassPricesQuery,
    NuSkuTeamBusinessClassPricesQueryVariables
  >(NuSkuTeamBusinessClassPricesDocument, options);
}
export function useNuSkuTeamBusinessClassPricesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        NuSkuTeamBusinessClassPricesQuery,
        NuSkuTeamBusinessClassPricesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NuSkuTeamBusinessClassPricesQuery,
    NuSkuTeamBusinessClassPricesQueryVariables
  >(NuSkuTeamBusinessClassPricesDocument, options);
}
export type NuSkuTeamBusinessClassPricesQueryHookResult = ReturnType<
  typeof useNuSkuTeamBusinessClassPricesQuery
>;
export type NuSkuTeamBusinessClassPricesLazyQueryHookResult = ReturnType<
  typeof useNuSkuTeamBusinessClassPricesLazyQuery
>;
export type NuSkuTeamBusinessClassPricesSuspenseQueryHookResult = ReturnType<
  typeof useNuSkuTeamBusinessClassPricesSuspenseQuery
>;
export type NuSkuTeamBusinessClassPricesQueryResult = Apollo.QueryResult<
  NuSkuTeamBusinessClassPricesQuery,
  NuSkuTeamBusinessClassPricesQueryVariables
>;
